import React from "react";
import Ipod from "./Ipod";

function App() {
  // calling the Ipod Component
  return (
    <div className="App">
      <Ipod />
    </div>
  );
}

export default App;
